import {
  EnvironmentProviders,
  InjectionToken,
  Optional,
  makeEnvironmentProviders,
} from '@angular/core';
import type { Messaging as FbMessaging } from 'firebase/messaging';
import {
  deleteToken as rawDeleteToken,
  getMessaging as rawGetMessaging,
  getToken as rawGetToken,
  isSupported as rawIsSupported,
  onMessage as rawOnMessage,
} from 'firebase/messaging';
import { kdvWrap } from '@fido/firebase';
import { FirebaseApp } from '@fido/firebase/app';
import { AppCheck } from '@fido/firebase/app-check';
import { Auth } from '@fido/firebase/auth';

// Wrapped firebase/messaging functions. blockUntilFirst values mirror
// @angular/fire's _zoneWrap declarations from angular-fire-messaging.mjs.
export const deleteToken = kdvWrap(rawDeleteToken, true);
export const getMessaging = kdvWrap(rawGetMessaging, true);
export const getToken = kdvWrap(rawGetToken, true);
export const isSupported = kdvWrap(rawIsSupported, false);
export const onMessage = kdvWrap(rawOnMessage, true);

export type { MessagePayload, GetTokenOptions } from 'firebase/messaging';

export type Messaging = FbMessaging;
export const Messaging = new InjectionToken<FbMessaging>('@fido/firebase.messaging');

export function provideMessaging(factory: () => FbMessaging): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: Messaging,
      // FirebaseApp + (Optional) Auth + (Optional) AppCheck — mirrors the
      // defensive deps @angular/fire declares on push-related providers,
      // even though messaging's upstream provider in angular-fire-messaging.mjs
      // doesn't list them, the parent FirebaseApps cascade does.
      useFactory: (_app: unknown, _auth: unknown, _appCheck: unknown) => factory(),
      deps: [FirebaseApp, [new Optional(), Auth], [new Optional(), AppCheck]],
    },
  ]);
}
